module.exports = __webpack_public_path__ + "static/media/elements-bg.c6243797.png";